import { useState, useEffect } from 'react'
import { getSexsAPI } from '../services/sexs'

function UseSexs() {
  const [data, setData] = useState([])

  useEffect(() => {
    const getData = async () => {
      const result = await getSexsAPI()
      if (!result) return

      const newData = result.result.map((d) => {
        return { value: d.sex_th, label: d.sex_th }
      })

      setData([
        ...newData,
      ])
    }

    getData()
  }, [])

  return data
}

export default UseSexs